/**
 * Force Localhost API - Redirects all Firebase Functions requests to localhost
 * This solves CORS issues and provides faster development experience
 */

// Only run in development mode
const isDevelopment = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     process.env.NODE_ENV === 'development';

if (!isDevelopment) {
  console.log('🚀 Force Localhost API script loading... (DISABLED FOR PRODUCTION)');
  console.log('✅ Production mode detected - using Firebase Functions API');
  // Exit early in production - just log and don't execute the rest
} else {
  console.log('🚀 Force Localhost API script loading... (DEVELOPMENT MODE)');

// DISABLED: Override fetch to redirect Firebase Functions requests to localhost
// const originalFetch = window.fetch;

// DISABLED FOR PRODUCTION
/*
window.fetch = async function(url, options = {}) {
  // Check if the URL is a Firebase Functions URL
  const firebaseUrls = [
    'api-aovv3tvopa-uc.a.run.app',
    'us-central1-wyenfosbills.cloudfunctions.net'
  ];
  
  const isFirebaseUrl = firebaseUrls.some(firebaseUrl => url.includes(firebaseUrl));
  
  if (isFirebaseUrl) {
    // Convert to localhost URL
    let localhostUrl = url;
    firebaseUrls.forEach(firebaseUrl => {
      localhostUrl = localhostUrl.replace(`https://${firebaseUrl}`, 'http://localhost:5000');
    });
    
    console.log('🔄 Redirecting Firebase Functions request to localhost:', localhostUrl);
    
    try {
      const response = await originalFetch(localhostUrl, options);
      console.log('✅ Localhost API response:', response.status);
      return response;
    } catch (error) {
      console.error('❌ Localhost API failed:', error);
      // Fallback to original URL if localhost fails
      return originalFetch(url, options);
    }
  }
  
  // For all other URLs, use original fetch
  return originalFetch(url, options);
};

// Override XMLHttpRequest to redirect Firebase Functions requests
const originalXHROpen = XMLHttpRequest.prototype.open;
const originalXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function(method, url, ...args) {
  this._originalUrl = url;
  
  // Check if the URL is a Firebase Functions URL
  const firebaseUrls = [
    'api-aovv3tvopa-uc.a.run.app',
    'us-central1-wyenfosbills.cloudfunctions.net'
  ];
  
  const isFirebaseUrl = firebaseUrls.some(firebaseUrl => url.includes(firebaseUrl));
  
  if (isFirebaseUrl) {
    let localhostUrl = url;
    firebaseUrls.forEach(firebaseUrl => {
      localhostUrl = localhostUrl.replace(`https://${firebaseUrl}`, 'http://localhost:5000');
    });
    
    console.log('🔄 XMLHttpRequest: Redirecting to localhost:', localhostUrl);
    this._redirectedUrl = localhostUrl;
    return originalXHROpen.call(this, method, localhostUrl, ...args);
  }
  
  return originalXHROpen.call(this, method, url, ...args);
};

XMLHttpRequest.prototype.send = function(data) {
  // Add error handling for redirected requests
  if (this._redirectedUrl) {
    this.addEventListener('error', (event) => {
      console.error('❌ Localhost API request failed:', event);
    });
    
    this.addEventListener('load', (event) => {
      if (this.status >= 200 && this.status < 300) {
        console.log('✅ Localhost API request successful:', this.status);
      }
    });
  }
  
  return originalXHRSend.call(this, data);
};

// Set localStorage flag to force localhost API
localStorage.setItem('forceLocalhostAPI', 'true');

// Override API_CONFIG to use localhost
if (window.API_CONFIG) {
  window.API_CONFIG.BASE_URL = 'http://localhost:5000';
}

  // DISABLED FOR PRODUCTION
  /*
  // Override axios defaults if available
  if (window.axios) {
    window.axios.defaults.baseURL = 'http://localhost:5000';
  }

  console.log('✅ Force Localhost API script loaded successfully!');
  console.log('🔄 All Firebase Functions requests will redirect to localhost:5000');
  */

  // DISABLED FOR PRODUCTION
  /*
  // Test localhost connection
  const testLocalhost = async () => {
    try {
      const response = await fetch('http://localhost:5000/health', {
        method: 'GET',
        signal: AbortSignal.timeout(3000)
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Localhost API test successful:', data);
        return true;
      } else {
        console.log('❌ Localhost API test failed:', response.status);
        return false;
      }
    } catch (error) {
      console.log('❌ Localhost API test error:', error.message);
      return false;
    }
  };

  // DISABLED FOR PRODUCTION
  /*
  // Run test after a short delay
  setTimeout(testLocalhost, 1000);

  // Export functions for manual use
  window.forceLocalhostAPI = () => {
    localStorage.setItem('forceLocalhostAPI', 'true');
    window.location.reload();
  };

  window.testLocalhostAPI = testLocalhost;

  window.disableLocalhostAPI = () => {
    localStorage.removeItem('forceLocalhostAPI');
    window.location.reload();
  };
  */
}